export default "__VITE_ASSET__DP56fedo__"